const state = {
    orderJobId: false,
    locationName: false
};

const actions = {};

const mutations = {
    SET_ORDER_JOB(state, payload) {
        state.orderJobId = payload;
    },
    SET_LOCATION_NAME(state, payload) {
        state.locationName = payload;
    }
};
   
export default {
    state,
    actions,
    mutations
}
   